import React from 'react';

const styling = {
    yellow: {
        bg: 'bg-darwin-accent-bright-yellow-200',
        border: 'border-darwin-accent-bright-yellow-800',
        text: 'text-darwin-neutral_new-1000',
    },
    blue: {
        bg: 'bg-darwin-accent-bright-blue-100',
        border: 'border-darwin-accent-bright-blue-800',
        text: 'text-darwin-accent-bright-blue-800',
    },
    green: {
        bg: 'bg-darwin-green-bg-light',
        border: 'border-darwin-green-primary',
        text: 'text-darwin-neutral_new-1000',
    },
    grey: {
        bg: 'bg-darwin-neutral_new-50',
        border: 'border-darwin-neutral_new-200',
        text: 'text-darwin-neutral_new-1000',
    },
};

type Colors = 'yellow' | 'blue' | 'green' | 'grey';

const Tag: React.FC<{
    text: string;
    icon: JSX.Element;
    color: Colors;
}> = ({ text, icon, color }) => (
    <div
        className={`flex items-center border gap-4 justify-center rounded-8 p-8 ${
            styling[color as Colors].bg
        } ${styling[color as Colors].border}`}
    >
        <span>{icon}</span>
        <p className={`font-400 ${styling[color as Colors].text}`}>{text}</p>
    </div>
);

export default Tag;
